// extracted by mini-css-extract-plugin
export default {"errorDialog":"errorDialog__zrhK3","dialog-confirm":"dialog-confirm","modalHeader":"modalHeader"};